function changeMainImage(product_id, image) {
  const mainImage = document.getElementById(`${product_id}mainImage`);
  mainImage.setAttribute('src', image);
}

function changeQuantity(isIncrement) {
  var quantityInput = document.querySelector('.quantity-input');
  var currentQuantity = parseInt(quantityInput.value, 10);

  if (isIncrement) {
    quantityInput.value = currentQuantity + 1;
  } else if (currentQuantity > 1) {
    quantityInput.value = currentQuantity - 1;
  }
}
function formatarTexto(texto) {
  return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
}
function previousItem() {
  const currentNumberKitElement = document.querySelector('.current-number-kit');

  const currentNumberKit = parseInt(currentNumberKitElement.innerHTML) - 1;
  // console.log(currentNumberKit);
  if (currentNumberKit === 1) {
    const previousButton = document.querySelector('.previous-button');
    previousButton.disabled = true;
  }
  currentNumberKitElement.innerText = currentNumberKit;
  const nextButton = document.querySelector('.next-button');
  const buttonAdd = document.querySelector('.add-to-cart-button');
  nextButton.style.display = 'inline-block';
  buttonAdd.style.display = 'none';
  const itemsLocalstorage = JSON.parse(localStorage.getItem('items'));

  const index = currentNumberKit - 1;
  const color = itemsLocalstorage[index].color;
  const size = itemsLocalstorage[index].size;

  document.querySelector(`[data-color=${formatarTexto(color)}]`).click();
  document.querySelector(`[data-size=${size.trim()}]`).click();
}

function listTamanhosByCor(variants, cor) {
  const tamanhos = new Set();
  variants.variants.forEach((variant) => {
    if (variant.options.Cor === cor && variant.stock > 0) {
      tamanhos.add(variant.options.Tamanho);
    }
  });
  return Array.from(tamanhos);
}

function listCoresByTamanho(variants, tamanho) {
  const cores = new Set();
  variants.variants.forEach((variant) => {
    if (variant.options.Tamanho === tamanho && variant.stock > 0) {
      cores.add(variant.options.Cor);
    }
  });
  return Array.from(cores);
}
function isColorAndSizeSelected(product_id, color, size) {
  const colorValue = document.querySelector('.color-value');
  const sizeValue = document.querySelector('.size-value');
  const isColor = color.innerText === 'SELECIONE UMA COR';
  const isSize = size.innerText === 'SELECIONE UM TAMANHO';
  if (isColor) {
    // errorElement.style.display = 'block';
    colorValue.style.color = 'red';
    return true;
  }

  if (isSize) {
    sizeValue.style.color = 'red';
    return true;
  }
  return false;
}
